import * as z from "zod";

export const TaskSchema = z.object({
  name: z.string(),
  hours: z.number(),
});
export const tasksSchema = z.array(TaskSchema);

export type Task = z.infer<typeof TaskSchema>;
export type Tasks = z.infer<typeof tasksSchema>;
